export default "/images/vendor/flag-icon-css/flags/4x3/kw.svg?2dce482defe9d86d05967143aaeb7d3a";